import {defineMessages} from 'react-intl';

export default defineMessages({
  message: {
    defaultMessage: 'Please wait for your challenge attempts to be graded. {br} This should take up to 2 days.',
    id: 'CourseDetailPage.ChallengesStatus.Message',
  },
});
